export const sidebarInit = (data) => {
    const side = document.querySelector(".Anchorlinks");

    if (side && innerWidth > 1024) {
        //カレント表示
        const lis = Array.from(
                side.querySelectorAll(".Anchorlinks ul li a")
            ).reverse(),
            cnts = Array.from(
                document.querySelectorAll(
                    ".pagecnt>section[id],.pagecnt .anchorlink"
                )
            ).reverse();

        setTimeout(() => {
            scroll();
        }, 500);

        window.addEventListener("scroll", scroll);

        function scroll() {
            let already = false;

            cnts.forEach((cnt, index) => {
                let cntPos = cnt.getBoundingClientRect();

                if (
                    cntPos.top <= innerHeight / 2 + 1 &&
                    cntPos.bottom >= innerHeight / 2 &&
                    !already
                ) {
                    lis[index].classList.add("is-crnt");
                    already = true;
                } else {
                    lis[index].classList.remove("is-crnt");
                }
            });
        }
    }
};
sidebarInit();
